import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/services/automation/automationpage.tsx");
